<template>
  <div class="zt-desc">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data: () => ({
    
  }),
}
</script>

<style lang="scss" scoped>
.zt-desc {
  font-size: 16px;
  color: $theme-textsecond;
  line-height: 30px;
  padding-bottom: 30px;
  /deep/ .app-link {
    color: $theme;
  }
}
</style>